var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"systemDetail section-main__warp"},[_c('div',{staticClass:"sysForm"},[_c('ioc-form',{attrs:{"option":_vm.addVcnOption},on:{"submit":_vm.submit,"reset-change":_vm.cancelBtn},model:{value:(_vm.sysDetData),callback:function ($$v) {_vm.sysDetData=$$v},expression:"sysDetData"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }